import importExport from './import&export.vue'
import moment from 'moment'
export default {
  components: { importExport },
  methods: {
    importProduct() {
      this.$refs['importExport'].importProduct();
    },
    // 导出 --新接口
    onExport() {
      
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let params = {  //办公平台
        taskDTO: {
          appCode: "ec-pc-new",
          // 数据过滤
          paramMap: {
            exportTag: true,
            ...this.formData
          },
          reportName: "saleNumListExport"
        },
        // 配置导出列
        columnDTOs: [
          // {
          //   columnName: '包件编码',
          //   parentColumnName: null,
          //   fieldName: 'packCode',
          //   fieldType: 'string',
          //   columnFormat: null
          // }
        ]
      };
      let labels = this.columnData.map(v=>v.label);
      let props = this.columnData.map(v=>v.prop);
      props.forEach((prop, index) => {
        params.columnDTOs.push({
          columnName: labels[index],
          parentColumnName: null,
          fieldName: prop,
          fieldType: 'string',
          columnFormat: null
        })
      })
      console.log(params);
      console.log(this.exportData);
      let exportColumn = []
      props.forEach((prop, index) => {
        exportColumn.push({
          columnName: labels[index],
          fieldName: prop,

        })
      })
      // this.exportColumn.exportColumn = exportColumn
      this.$set(this.exportData,'exportColumn',exportColumn)
      if(this.activeTable == 0) {
        this.$q.goodsAnalysis.saleProduct({data: this.exportData,options: {responseType: 'blob'}}).then((res) => {
          console.log(res)
          loading.close();
          let fileName = '年度销售产品上新概览'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.blobDownload( res, `${fileName}.xls`);
        });
      }else if(this.activeTable == 1) {
        this.$q.goodsAnalysis.priceSegmentDistrExport({data: this.exportData,options: {responseType: 'blob'}}).then((res) => {
          console.log(res)
          loading.close();
          let fileName = '价格分布段'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.blobDownload( res, `${fileName}.xls`);
         
        });
      }else if(this.activeTable == 2) {
        this.$q.goodsAnalysis.hundredSaleNum({data: this.exportData,options: {responseType: 'blob'}}).then((res) => {
          console.log(res)
          let fileName = '月均销售过百的价格段分布'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.blobDownload( res, `${fileName}.xls`);
          loading.close();
        });
      }else if(this.activeTable == 3) {
        this.$q.goodsAnalysis.saleNumListExport({data: this.exportData,options: {responseType: 'blob'}}).then((res) => {
          console.log(res)
          let fileName = '月均销售过百的价格段分布'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.blobDownload( res, `${fileName}.xls`);
          loading.close();
        });
      }else if(this.activeTable == 4) {
        this.$q.goodsAnalysis.newProSaleNumListExport({data: this.exportData,options: {responseType: 'blob'}}).then((res) => {
          console.log(res)
          let fileName = '销量表现'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.blobDownload( res, `${fileName}.xls`);
          loading.close();
        });
      }else if(this.activeTable == 5) {
        this.$q.goodsAnalysis.salesSamePeriodList({data: this.exportData,options: {responseType: 'blob'}}).then((res) => {
          console.log(res)
          let fileName = '销售数据同期比'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.blobDownload( res, `${fileName}.xls`);
          loading.close();
        });
      }
      // 不导出图片列
      // params.columnDTOs = params.columnDTOs.filter(v=>v.columnName !== '图片');
      // this.$q.common.exportExcel({data: params}).then((res) => {
      //   console.log(res)
      //   loading.close();
      //   this.$message({
      //     type: "success",
      //     message: "导出成功,请在导出列表中查看",
      //   });
      // });
    },
  }
}